module.exports = __webpack_public_path__ + "img/1.d8ff4d39.svg";